// Art & Event Description Toggle
document.addEventListener('DOMContentLoaded', () => {
  // Set the read less text from locale
  const locale = document.documentElement.lang || 'fr';
  const translations = {
    'fr': 'Lire moins',
    'en': 'Read less',
    'zh-CN': '收起'
  };
  const readLessTranslated = translations[locale] || translations['fr'];

  // Initialize toggle functionality for a given wrapper type
  const initToggle = (wrapperSelector, descriptionSelector, toggleSelector) => {
    const wrappers = document.querySelectorAll(wrapperSelector);

    wrappers.forEach((wrapper) => {
      const description = wrapper.querySelector(descriptionSelector);
      const toggleButton = wrapper.querySelector(toggleSelector);

      if (!description || !toggleButton) return;

      // Function to check if content is truncated
      const checkTruncation = (source = 'unknown') => {
        // Get the clamped height first
        const clampedHeight = description.clientHeight;

        // Temporarily add 'expanded' class to remove line-clamp and measure full height
        // Also add to any nested elements with the same class (for product descriptions with wrapper divs)
        description.classList.add('expanded');
        const nestedDescriptions = description.querySelectorAll('.event-card__description, .art-description');
        nestedDescriptions.forEach(nested => nested.classList.add('expanded'));

        // Force browser reflow by reading offsetHeight
        void description.offsetHeight;

        const fullHeight = description.scrollHeight;

        // Remove the 'expanded' class to restore line-clamp
        description.classList.remove('expanded');
        nestedDescriptions.forEach(nested => nested.classList.remove('expanded'));

        // Force another reflow
        void description.offsetHeight;

        // Check if content is being clamped by comparing full height with clamped height
        // Use a threshold of 5px to account for subpixel rounding and paragraph margins
        const isClamped = fullHeight > clampedHeight + 5;

        const action = isClamped ? 'SHOW button' : 'HIDE button';

        // Debug logging (remove after testing)
        console.log(`[${source}] ${action}:`, {
          clampedHeight,
          fullHeight,
          difference: fullHeight - clampedHeight,
          isClamped,
          buttonWillBe: isClamped ? 'block' : 'none',
          element: description
        });

        if (isClamped) {
          toggleButton.style.display = 'block';
          console.log(`[${source}] ✓ Set button display to:`, toggleButton.style.display, 'Actual computed style:', window.getComputedStyle(toggleButton).display);

          // Add a marker to track this button
          toggleButton.setAttribute('data-should-be-visible', 'true');
        } else {
          toggleButton.style.display = 'none';
          console.log(`[${source}] ✗ Set button display to:`, toggleButton.style.display);
          toggleButton.setAttribute('data-should-be-visible', 'false');
        }
      };

      // Debug: Watch for changes to the button's display property
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
            const currentDisplay = window.getComputedStyle(toggleButton).display;
            const shouldBeVisible = toggleButton.getAttribute('data-should-be-visible');

            if (shouldBeVisible === 'true' && currentDisplay === 'none') {
              console.error('🔴 BUTTON HIDDEN BY EXTERNAL CODE!', {
                button: toggleButton,
                parentWrapper: wrapper,
                stackTrace: new Error().stack
              });
            }
          }
        });
      });

      observer.observe(toggleButton, {
        attributes: true,
        attributeFilter: ['style']
      });

      // Get translations from the button's data attributes
      const readMoreText = toggleButton.textContent;

      // Toggle function
      toggleButton.addEventListener('click', (e) => {
        e.preventDefault();
        const isExpanded = description.classList.contains('expanded');
        const nestedDescriptions = description.querySelectorAll('.event-card__description, .art-description');

        if (isExpanded) {
          description.classList.remove('expanded');
          nestedDescriptions.forEach(nested => nested.classList.remove('expanded'));
          toggleButton.textContent = readMoreText;
        } else {
          description.classList.add('expanded');
          nestedDescriptions.forEach(nested => nested.classList.add('expanded'));
          toggleButton.textContent = readLessTranslated;
        }
      });

      // Initial check - use requestAnimationFrame to ensure layout is complete
      requestAnimationFrame(() => {
        checkTruncation('requestAnimationFrame');

        // Additional check after a short delay to account for font loading
        setTimeout(() => {
          if (!description.classList.contains('expanded')) {
            checkTruncation('setTimeout-100ms');
          }
        }, 100);
      });

      // Recheck on window resize
      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          if (!description.classList.contains('expanded')) {
            checkTruncation('resize');
          }
        }, 250);
      });
    });
  };

  // Initialize for art descriptions
  initToggle('.art-description-wrapper', '.art-description', '.art-description-toggle');

  // Initialize for event descriptions
  initToggle('.event-description-wrapper', '.event-card__description', '.event-description-toggle');
});
